import {
  Box,
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { CONFIG } from "../config";

const UserEntityApproval = () => {
  const [centreId, setCentreId] = useState("");
  const [centres, setCentres] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isSavingVisible, setIsSavingVisible] = useState(false);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [actionType, setActionType] = useState("create");
  const [idToUpdate, setIdToUpdate] = useState("");

  const fetchData = useCallback(async (query, centreId, setter) => {
    console.log(query);
    console.log(centreId);
    if (CONFIG.SYSTEM_WITH_MENU_SYSTEM) {
      try {
        if (query === "getAllUsers") {
          const consolidatedEntityAll = await axios.get(CONFIG.EXPERT_SERVER_URL + `/consolidatedCompanyEntity/filter?schoolId=` + centreId);
          const response = await axios.get(CONFIG.MAIN_URL + '/user/filter?schoolId=' + centreId);
          const allUsers = response.data.filter(itemX => itemX.isActive === true && itemX.mainIamRole != null && itemX.mainIamRole === 'volunteer')
          const response1 = await axios.get(CONFIG.MAIN_URL + '/userRole/filter?schoolId=' + centreId);
          const allRoles = response1.data.filter(itemX => itemX.isActive === true);
          console.log(consolidatedEntityAll);
          console.log(allUsers);
          console.log(allRoles);

          var arr = [];
          allUsers.forEach((item) => {
            var obj = {};
            obj["lastName"] = item.lastName;
            obj["name"] = item.firstName;
            obj["userId"] = item.userId;
            var arr1 = [];

            allRoles.forEach((item1) => {
              if (item1.userId === item.userId && item1.isActive) {
                var obj1 = {};
                obj1["roleId"] = item1.roleid;
                obj1["isActive"] = item1.isActive;
                const activeEntity = consolidatedEntityAll.data.find(itemX => itemX.entityId === item1.entityId)
                var obj2 = {};
                obj2["entityId"] = activeEntity.entityId;
                obj2["entityName"] = activeEntity.entityName;
                obj1["entity"] = obj2;
                arr1.push(obj1);
              }
            })
            obj["userRole"] = arr1;
            arr.push(obj);
          })
          console.log(arr);
          setter(arr);

        } else {
          if (query === "allEntityList") {

            const basicEntityAll = await axios.get(CONFIG.EXPERT_SERVER_URL + `/basicEntity/filter?schoolId=` + centreId);
            if (basicEntityAll.data != undefined && basicEntityAll.data != null && basicEntityAll.data.length > 0) {
              console.log(basicEntityAll.data);
              const consolidatedEntityAll = await axios.get(CONFIG.EXPERT_SERVER_URL + `/consolidatedCompanyEntity/filter?schoolId=` + centreId);
              console.log(consolidatedEntityAll.data);
              var arr = [];
              consolidatedEntityAll.data.forEach((item) => {
                var obj = {};
                obj["entityId"] = item.entityId
                obj["entityName"] = item.entityName
                obj["isActive"] = item.isActive
                const bacicEntity = basicEntityAll.data.find(itemX => itemX.basicEntityId === item.basicEntityId);
                var obj1 = {};
                obj1["basicEntityId"] = bacicEntity.basicEntityId;
                obj1["iamRole"] = bacicEntity.iamRole;
                obj["basicEntity"] = obj1;
                arr.push(obj);
              })
              console.log(arr);
              setter(arr);

            }

          } else {
            const response = await axios.get(CONFIG.MAIN_URL + query);
            setter(response.data);
          }
        }
      } catch (error) {
        console.error("Error fetching data", error);
      }
    } else {
      try {
        const response = await axios.post(CONFIG.MAIN_URL + "/graphql", query, {
          headers: { "Content-Type": "text/plain" },
        });
        console.log(response.data.data);
        setter(response.data.data);
      } catch (error) {
        console.error("Error fetching data", error);
      }
    }
  }, []);

  const fetchCentres = useCallback(() => {
    const centId = "";
    if (CONFIG.SYSTEM_WITH_MENU_SYSTEM) {
      const query = "/centre/all";
      fetchData(query, centId, (data) => setCentres(data));
    } else {
      const query = "{getAllCentreList{centreId,centreName}}";
      fetchData(query, centId, (data) => setCentres(data.getAllCentreList));
    }

  }, [fetchData]);

  const fetchUsers = (centreId) => {
    if (CONFIG.SYSTEM_WITH_MENU_SYSTEM) {
      const query = "getAllUsers";
      fetchData(query, centreId, (data) => setUsers(data));
    } else {
      const query = `{getAllUsers(centreId:"${centreId}",roleId:"volunteer"){userId,name,lastName,userRole{roleId,isActive,entity{entityId,entityName}}}}`;
      fetchData(query, centreId, (data) => setUsers(data.getAllUsers));
    }
  };

  const fetchRoles = (centreId) => {
    if (CONFIG.SYSTEM_WITH_MENU_SYSTEM) {
      const query = "allEntityList";
      fetchData(query, centreId, (data) => setRoleList(data));
    } else {
      const query = `{allEntityList(centreId:"${centreId}"){entityDataList{entityId,entityName,isActive,basicEntity{basicEntityId,iamRole}}}}`;
      fetchData(query, centreId, (data) => setRoleList(data.allEntityList.entityDataList));
    }
  };

  useEffect(() => {
    fetchCentres();
  }, [fetchCentres]);

  const handleCentreChange = (event) => {
    const selectedCentre = event.target.value;
    clearSelections();
    setCentreId(selectedCentre);
    fetchUsers(selectedCentre);
    fetchRoles(selectedCentre);
  };

  const handleUserChange = (event) => {
    setSelectedUser(event.target.value);
    setSelectedRoles([]);
  };

  const clearSelections = () => {
    setCentreId("");
    setUsers([]);
    setSelectedUser(null);
    setIsSavingVisible(false);
    setSelectedRoles([]);
    setRoleList([]);
    setActionType("create");
    setIdToUpdate("");
  };

  const loadUserEntityAllocation = async (userId) => {
    try {
      const response = await axios.get(
        `${CONFIG.MAIN_URL}/userEntityAllocation/filter?userCode=${userId}`
      );
      const allocationData = response.data;

      if (allocationData.length > 0) {
        setActionType("update");
        setIdToUpdate(allocationData[0].id);
        const entityIds = allocationData[0].entityAllocationData.map(
          (item) => parseInt(item.entityId)
        );
        setSelectedRoles(entityIds);
      }
    } catch (error) {
      console.error("Error loading user entity allocation", error);
    }
  };

  const handleShowSaveSection = async () => {
    if (centreId && selectedUser) {
      setIsSavingVisible(true);
      await loadUserEntityAllocation(selectedUser.userId);
    }
  };

  const toggleRoleSelection = (roleId) => {
    setSelectedRoles((prevSelectedRoles) =>
      prevSelectedRoles.includes(roleId)
        ? prevSelectedRoles.filter((id) => id !== roleId)
        : [...prevSelectedRoles, roleId]
    );
  };

  const saveRoles = async () => {
    try {
      const selectedRoleData = roleList.filter((role) =>
        selectedRoles.includes(role.entityId)
      );
      const payload = {
        id: idToUpdate,
        centreId,
        userCode: selectedUser.userId,
        entityAllocationData: selectedRoleData.map((role) => ({
          roleId: role.basicEntity.iamRole,
          isActive: role.isActive,
          entityId: role.entityId,
          entityName: role.entityName,
          isApproved: true,
        })),
      };

      await axios.post(`${CONFIG.MAIN_URL}/userEntityAllocation/${actionType}`, payload);

      alert(idToUpdate ? "Roles updated successfully!" : "Roles saved successfully!");
      clearSelections();
    } catch (error) {
      console.error("Error saving roles", error);
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={4}>
        <FormControl fullWidth>
          <TextField
            label="Select a Centre"
            select
            value={centreId}
            onChange={handleCentreChange}
            variant="outlined"
          >
            {centres.map((item) => (
              <MenuItem key={CONFIG.SYSTEM_WITH_MENU_SYSTEM ? item.schoolId : item.centreId} value={CONFIG.SYSTEM_WITH_MENU_SYSTEM ? item.schoolId : item.centreId}>
                {CONFIG.SYSTEM_WITH_MENU_SYSTEM ? item.schoolName : item.centreName} ({CONFIG.SYSTEM_WITH_MENU_SYSTEM ? item.schoolId : item.centreId})
              </MenuItem>
            ))}
          </TextField>
        </FormControl>
      </Grid>

      {centreId && (
        <>
          <Grid item xs={4}>
            <FormControl fullWidth>
              <TextField
                label="Select an User"
                select
                value={selectedUser}
                onChange={handleUserChange}
                variant="outlined"
              >
                {users.map((user) => (
                  <MenuItem key={user.userId} value={user}>
                    {user.name} {user.lastName}
                  </MenuItem>
                ))}
              </TextField>
            </FormControl>
          </Grid>

          <Grid item xs={4}>
            <Button variant="contained" onClick={handleShowSaveSection}>
              SELECT
            </Button>
            &nbsp;
            <Button variant="outlined" onClick={clearSelections}>
              CLEAR
            </Button>
          </Grid>
        </>
      )}

      {isSavingVisible && selectedUser && (
        <>
          <Grid item xs={12} sx={{ marginTop: -2 }}>
            <Typography variant="h8" style={{ fontWeight: 'bold'/*fontFamily:'fantasy'*/ }}>User Requested Roles</Typography>
            <Card sx={{ padding: 2, maxHeight: 100, overflowY: "auto" }}>
              <CardContent>
                <Grid container>
                  {selectedUser.userRole.map((role, index) => (
                    <Grid item xs={4} key={index}>
                      {index + 1}. {role.entity.entityName}
                    </Grid>
                  ))}
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} sx={{ marginTop: -2 }}>
            <Typography variant="h8" style={{ fontWeight: 'bold'/*fontFamily:'fantasy'*/ }}>Approve Roles</Typography>
            <Card sx={{ padding: 2, maxHeight: 150, overflowY: "auto" }}>
              <CardContent>
                <Grid container>
                  {roleList
                    .filter((item) => item.basicEntity.iamRole != 'ADMIN')
                    .map((role, index) => (
                      <Grid item xs={4} key={role.entityId}>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <input
                            type="checkbox"
                            checked={selectedRoles.includes(role.entityId)}
                            onChange={() => toggleRoleSelection(role.entityId)}
                          />
                          <Typography sx={{ marginLeft: 1 }}>
                            {role.entityName}
                          </Typography>
                        </Box>
                      </Grid>
                    ))}
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} sx={{ marginTop: -2 }}>
            <Button
              variant="contained"
              onClick={saveRoles}
              sx={{ float: "right" }}
            >
              {idToUpdate ? "UPDATE" : "SAVE"}
            </Button>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default UserEntityApproval;



